var config = {
    'api': 'https://api.gearfury.com/',
    'static': 'https://images.gearfury.com/static/',
    'images': 'https://images.gearfury.com/',
    'fulfillment': {0: 'Waiting', 1: 'Submitted', 2: 'Unpaid', 3: 'Paid'},
    'fulfillment_billing': {0: 'Unpaid', 1: 'Paid'},
    'fulfillment_billing_class': {0: 'btn-danger', 1: 'btn-success'},
    'order': {0: 'New', 1: 'Paid', 2: 'Cancelled', 3: 'Shipped'},
    'order_class': {0: '', 1: 'text-success', 2: 'text-danger', 3: 'text-primary'},
    'integrates': {
        'woocommerce': {
            'name': 'GearFury',
            'callback_url': 'https://api.gearfury.com/integrate/callback/woocommerce',
            'return_url': 'http://localhost:8080/integrate/woocommerce',
        }
    },
    'integrate_types': {
        'etsy': 1,
        'woocommerce': 2,
        'shopify': 3

    }
}

export default config;
